import React, { useState } from "react";
import styled, { css } from "styled-components";
import { Theme } from "../../../theme";
import { Drawer, Divider } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import clsx from "clsx";
import SidebarNav from "./SidebarNav";
import Profile from "./Profile";

const StyledSection = styled.section`
  ${({ theme }: { theme: Theme }) => {
    return css`
      .drawer {
        /* None of this css affects minified version */
        width: 240px;
        ${theme.breakpoints.up("lg")}{
            margin-top: 64px;
            height: calc(100% - 64px);
        }
      }
      .root {
        background-color: ${theme.palette.common.white}
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: ${theme.spacing(2)}px;
      }
      .divider {
        margin: ${theme.spacing(2, 0)}px;
      }
      .nav {
        margin-bottom: ${theme.spacing(2)}px;
      }
    `;
  }};
`;

export interface SidebarProps {
  onLogoutOpen: () => void;
  pages: { title: string; href: string; icon: JSX.Element }[];
  [key: string]: any;
}

const Sidebar: React.FC<SidebarProps> = props => {
  const {
    userDetails,
    pages,
    onClose,
    open,
    variant,
    className,
    ...rest
  } = props;
  const theme: Theme = useTheme();

  return (
    <>
      <StyledSection theme={theme}>
        <p>TESTING TESTING</p>
        <Drawer
          anchor="left"
          classes={{ paper: "drawer" }}
          onClose={onClose}
          open={open}
          variant={variant}
        >
          <div {...rest} className={clsx("root", className)}>
            {/* <Profile userDetails={userDetails} /> */}
            {/* <Divider className="divider" /> */}
            <SidebarNav
              className="nav"
              pages={pages}
              onLogoutOpen={props.onLogoutOpen}
            />
          </div>
        </Drawer>
      </StyledSection>
    </>
  );
};

export default Sidebar;
